module.exports = "/wwwroot/img/linkedin-in-brands.svg?ver=98e3062a";